import React from 'react';
import '../../styles/Auth/Header.css';
import ProfileDropdown from './ProfileDropDown.jsx';
// import { useLocation } from 'react-router-dom';
const Header = () => {
  // const location = useLocation();


  return (
    <header className="dashboard-header">
      <ProfileDropdown />
      
    </header>
  );
};

export default Header;
